import { render } from "./UnderstandingDigu.vue?vue&type=template&id=1d193d8a&scoped=true"
import script from "./UnderstandingDigu.vue?vue&type=script&lang=js"
export * from "./UnderstandingDigu.vue?vue&type=script&lang=js"

import "./UnderstandingDigu.vue?vue&type=style&index=0&id=1d193d8a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d193d8a"]])

export default __exports__